import { enableLogging } from 'mobx-logger';
import React from 'react';
import ReactDOM from 'react-dom';
import './src/InitializeConfig';
import App from './src/App';
import { configure } from 'mobx';

// uncomment if developing or debugging locally, may produce performance decrease due to many logs
configure({
  enforceActions: 'observed',
  isolateGlobalState: false
  // observableRequiresReaction: true,
  // computedRequiresReaction: true,
  // reactionRequiresObservable: true
});

if (DEVELOPMENT) {
  enableLogging({
    action: true,
    transaction: true,
    compute: true
  });
}

const initialState: InitialStateHolder = { initialState: window.INITIAL_STATE, app: ['diil', 'super'].includes(window.APP) ? window.APP : null };

const render = (AppComponent: React.ComponentClass, props: InitialStateHolder) => {
  ReactDOM.hydrate(<AppComponent {...props} />, document.getElementById('container'));
};

render(App, initialState);
